import { 
  QuestionBank, 
  QuestionBankCreateRequest, 
  QuestionBankUpdateRequest,
  QuestionBankImportResponse
} from '../../../shared/types/database';

const API_BASE = '/api/v1/question-bank';

export const questionBankService = {
  // Lấy danh sách câu hỏi
  async getQuestions(monHocId?: string): Promise<QuestionBank[]> {
    const params = new URLSearchParams();
    if (monHocId) {
      params.append('monHocId', monHocId);
    }
    
    const token = localStorage.getItem('quanly_truonghoc_token');
    
    const response = await fetch(`${API_BASE}?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Lỗi khi lấy danh sách câu hỏi');
    }
    
    return await response.json();
  },

  // Thêm câu hỏi mới
  async createQuestion(data: QuestionBankCreateRequest): Promise<QuestionBank> {
    const token = localStorage.getItem('quanly_truonghoc_token');
    
    const response = await fetch(API_BASE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Lỗi khi thêm câu hỏi');
    }
    
    return await response.json();
  },

  // Cập nhật câu hỏi
  async updateQuestion(cauHoiId: number, data: QuestionBankUpdateRequest): Promise<QuestionBank> {
    const token = localStorage.getItem('quanly_truonghoc_token');
    
    const response = await fetch(`${API_BASE}/${cauHoiId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Lỗi khi cập nhật câu hỏi');
    }
    
    return await response.json();
  },

  // Xóa câu hỏi
  async deleteQuestion(cauHoiId: number): Promise<{ success: boolean; message: string }> {
    const token = localStorage.getItem('quanly_truonghoc_token');
    
    const response = await fetch(`${API_BASE}/${cauHoiId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Lỗi khi xóa câu hỏi');
    }
    
    return await response.json();
  },

  // Import câu hỏi từ Excel
  async importQuestions(MonHocID: string, file: File): Promise<QuestionBankImportResponse> {
    const token = localStorage.getItem('quanly_truonghoc_token');
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('MonHocID', MonHocID);
    
    const response = await fetch(`${API_BASE}/import`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Lỗi khi import câu hỏi');
    }
    
    return await response.json();
  }
};
